/*!
 * devextreme-angular
 * Version: 19.1.3
 * Build date: Tue May 14 2019
 *
 * Copyright (c) 2012 - 2019 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */


import {
    Component,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';





import { NestedOptionHost } from '../../core/nested-option';
import { NestedOption } from '../../core/nested-option';


@Component({
    selector: 'dxo-image',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
})
export class DxoImageComponent extends NestedOption {
    @Input()
    get height(): number | { rangeMaxPoint?: number, rangeMinPoint?: number } {
        return this._getOption('height');
    }
    set height(value: number | { rangeMaxPoint?: number, rangeMinPoint?: number }) {
        this._setOption('height', value);
    }

    @Input()
    get url(): string | { rangeMaxPoint?: string, rangeMinPoint?: string } {
        return this._getOption('url');
    }
    set url(value: string | { rangeMaxPoint?: string, rangeMinPoint?: string }) {
        this._setOption('url', value);
    }

    @Input()
    get width(): number | { rangeMaxPoint?: number, rangeMinPoint?: number } {
        return this._getOption('width');
    }
    set width(value: number | { rangeMaxPoint?: number, rangeMinPoint?: number }) {
        this._setOption('width', value);
    }

    @Input()
    get location(): string {
        return this._getOption('location');
    }
    set location(value: string) {
        this._setOption('location', value);
    }


    protected get _optionPath() {
        return 'image';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }

}

@NgModule({
  declarations: [
    DxoImageComponent
  ],
  exports: [
    DxoImageComponent
  ],
})
export class DxoImageModule { }
